export enum TAG_FORM_TYPE {
  EDIT = 'EDIT',
  NEW = 'NEW',
}
